import { createApp } from 'vue'
import { createPinia } from 'pinia';
import './registerServiceWorker'

import axios from 'axios'
import VueAxios from 'vue-axios'

import dayjs from 'dayjs'
require('dayjs/locale/es')

import VueGtag from 'vue-gtag'

import {LoadingPlugin} from 'vue-loading-overlay';

import './vee-validate'

import router from './router'
import App from './App.vue'


// Contenedor de Google Ads usado para el seguimiento de conversiones.
const GOOGLE_ADS_ID = 'AW-18019975741';

axios.defaults.baseURL = process.env.VUE_APP_BACK;
dayjs.locale('es');

export const pinia = createPinia();

const app = createApp(App);
app.use(pinia)
app.use(VueAxios, axios)
app.use(router)
app.use(LoadingPlugin)

if (process.env.VUE_APP_GOOGLE_ID) {
    const gtagOptions = {
        config: {
            id: process.env.VUE_APP_GOOGLE_ID
        }
    };

    // El contenedor de Google Ads debe cargarse para que las conversiones
    // enviadas con send_to: 'AW-.../...' lleguen a registrarse. Sólo en
    // producción, para no ensuciar la cuenta con conversiones de prueba.
    if (process.env.NODE_ENV === 'production') {
        gtagOptions.includes = [{ id: GOOGLE_ADS_ID }];
    }

    app.use(VueGtag, gtagOptions, router);
}
app.config.globalProperties.dayjs = dayjs;
app.mount('#app');
export default app;
